var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('woot-reports',{key:"team-reports",attrs:{"type":"team","getter-key":"teams/getTeams","action-key":"teams/get","download-button-label":_vm.$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')}})}
var staticRenderFns = []

export { render, staticRenderFns }